import ContactEmail from './ContactEmail';
import CurrentPlan from './CurrentPlan';
// import PaymentMethod from './PaymentMethod';

const ManageBilling = () => {
    return (
        <div className="d-flex align-items-center mx-5">
            <ContactEmail />
            <CurrentPlan />
            {/* <PaymentMethod /> */}
        </div>
    );
};

export default ManageBilling;
